import { type BrowserHistory, createBrowserHistory } from "history"

const browserHistory: BrowserHistory = createBrowserHistory()

export { browserHistory }
